import React from "react";
import Userpage from "../components/user/Userpage";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Dashboardheader from "../components/Dashboardheader";
function UserDashboard() {
    return (
        <>
            {/* <Header /> */}
            <Dashboardheader />
            <Userpage />
            <Footer />
        </>
    );
}

export default UserDashboard;
